import 'typeface-roboto'
import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter } from 'react-router-dom'
import { Provider } from 'react-redux';

import App from "./App";
import store from './store';
import TimeAgo from 'javascript-time-ago'
import en from 'javascript-time-ago/locale/en';
// import Loader from './LoadingIndicator';

TimeAgo.addDefaultLocale(en)
ReactDOM.render((
  <Provider store={store}>
    <HashRouter>
      <App />
    </HashRouter>
  </Provider>
), document.getElementById('root'));

